<dw-ui-dialog-box
  [title]="'Doc::SupplierPreparation:GenerateReception' | abpLocalization"
  [saveDisabled]="form.invalid"
  [saveBusy]="isSaving()"
  [saveLabel]="'Doc::SupplierPreparation:GenerateReception' | abpLocalization"
  (saveFn)="generate()"
>
  <form [formGroup]="form">
    <div class="row">
      <div class="col-12 mb-3">
        <label for="dayBookId" class="form-label text-primary" dwInputRequired>
          {{ 'Doc::DayBook' | abpLocalization }}
        </label>
        <ng-select
          id="dayBookId"
          formControlName="dayBookId"
          [items]="dayBooks()"
          bindLabel="code"
          bindValue="id"
          [clearable]="false"
        ></ng-select>
      </div>
    </div>
  </form>
</dw-ui-dialog-box>
